import { ReviewsPageContent } from './shipsticks.page.content'

const content: ReviewsPageContent = {
  hero: {
    backgroundImage: '/images/shipskis/reviews-hero.jpg',
    title: "Thousands of skiers trust us. Here's why.",
    subtitle:
      'Read real reviews from customers who ditched the baggage claim and never looked back.',
  },
  trustpilotBusinessUnitId: '5465091d00006400057b85d1',
  trustpilotCTA: 'View all of ShipSkis real customer reviews on TrustPilot',
}

export default content
